import {
  DoctorProviderIconSVG,
  FacilityProviderIconSVG,
} from '../../../img/uploadDocument/uploadDocumentSVG';
import { TrashIcon, CrossDeleteIcon } from '../../../img/findcare/FindCareSVG';

const DoctorCard = ({
  selectedDocTypeData,
  deleteSelectedDocype,
  physicianType,
  showTrashIcon = true,
}) => {
  return (
    <div className="document-type-user-spec m-0">
      <div className="d-flex flex-row justify-content-between align-items-center p-0 document-facility-doctor px-3 h-100">
        <div className="d-flex flex-row align-items-center">
          {physicianType === 'D' ? (
            <DoctorProviderIconSVG className="document_providericonsvg" />
          ) : (
            <FacilityProviderIconSVG className="document_providericonsvg" />
          )}
          <div className="pl-2 d-flex flex-column">
            <span className="document-facility-info1">
              {physicianType === 'D'
                ? `${selectedDocTypeData.LastName}, ${selectedDocTypeData.FirstName} ${selectedDocTypeData.MiddleName}`
                : selectedDocTypeData.FacilityName}
            </span>
            <span className="document-facility-info2">
              {physicianType === 'D'
                ? selectedDocTypeData.Specialty
                : selectedDocTypeData.Address[0].address1 +
                  ',' +
                  selectedDocTypeData.Address[0].city +
                  ',' +
                  selectedDocTypeData.Address[0].state_prov +
                  ',' +
                  selectedDocTypeData.Address[0].postalCode}
            </span>
          </div>
        </div>
        <div className="d-flex">
          <div className="d-flex flex-column">
            {selectedDocTypeData.NationalProviderId && (
              <div className="pr-3 document-facility-info2">
                NPI: {selectedDocTypeData.NationalProviderId}
              </div>
            )}
            {selectedDocTypeData.TaxId && (
              <div className="pr-3 document-facility-info2">
                Tax ID: {selectedDocTypeData.TaxId}
              </div>
            )}
            {selectedDocTypeData.TaxID && (
              <div className="pr-3 document-facility-info2">
                Tax ID: {selectedDocTypeData.TaxID}
              </div>
            )}
          </div>
          {showTrashIcon && (
            <div className="trash-div">
              <button
                type="button"
                className="trash-button"
                onClick={deleteSelectedDocype}
              >
                <TrashIcon />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const BrokerCard = ({
  selectedDocTypeData,
  deleteSelectedDocype,
  physicianType,
  showTrashIcon = true,
}) => {
  return (
    <div className="document-type-user-spec m-0">
      <div className="d-flex flex-row justify-content-between align-items-center p-0 document-facility-doctor px-3 h-100">
        <div className="d-flex flex-row align-items-center">
          {/*{physicianType === 'D' ? (
            <DoctorProviderIconSVG className="document_providericonsvg" />
          ) : (
            <FacilityProviderIconSVG className="document_providericonsvg" />
          )} */}
          <div className="pl-2 d-flex flex-column">
            <span className="document-facility-info1">
              {selectedDocTypeData.BrokerName}
            </span>
            <span className="document-facility-info2">
              Type: {selectedDocTypeData.BrokerTypeDesc}{' '}
              {selectedDocTypeData.Parent &&
                `| Parent : ${selectedDocTypeData.Parent}`}
            </span>
          </div>
        </div>
        <div className="d-flex">
          <div className="d-flex flex-column">
            {selectedDocTypeData.Code && (
              <div className="pr-3 document-facility-info2">
                ID: {selectedDocTypeData.Code}
              </div>
            )}
            {selectedDocTypeData.TaxID && (
              <div className="pr-3 document-facility-info2">
                Tax ID: {selectedDocTypeData.TaxID}
              </div>
            )}
          </div>
          {showTrashIcon && (
            <div className="trash-div">
              <button
                type="button"
                className="trash-button"
                onClick={deleteSelectedDocype}
              >
                <TrashIcon />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const BlobCard = ({
  selectedDocTypeData,
  docTypeMeta,
  deleteSelectedDocype,
  setLoadLocation,
  docType,
  setOpenBlobModal,
  selectedLocationData,
  deleteLocationHandler,
  showTrashIcon = true,
}) => {
  return (
    <div
      className={`selected-data-box ${
        docType.value === 'Location' && ' location-data-box'
      }`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <span>
          {selectedDocTypeData[docTypeMeta.displayLabel]}{' '}
          {docTypeMeta.displaySubLabel && (
            <span className="pl-1">{`(${docTypeMeta.displaySubLabel})`}</span>
          )}
        </span>
        <div className="trash-div">
          {docType.value === 'Location' && !selectedLocationData && (
            <button
              type="button"
              className="panel-card-link"
              onClick={() => {
                setLoadLocation(true);
                setOpenBlobModal(true);
              }}
            >
              Select Location
            </button>
          )}
          {showTrashIcon && (
            <button
              type="button"
              className="trash-button"
              onClick={deleteSelectedDocype}
            >
              <TrashIcon />
            </button>
          )}
        </div>
      </div>
      {selectedLocationData && (
        <div className="selected-loacation-box">
          <span className="location-container">
            {selectedLocationData.LocationName}
          </span>
          {showTrashIcon && (
            <span className="cross-delete-icon" onClick={deleteLocationHandler}>
              <CrossDeleteIcon />
            </span>
          )}
        </div>
      )}
    </div>
  );
};
const MemberDependentCard = ({
  selectedDocTypeData,
  deleteSelectedDocype,
  getMaskedSsn,
}) => {
  return (
    <div className="document-type-user-spec m-0">
      <div className="d-flex flex-row justify-content-between align-items-center p-0 document-facility-doctor px-3 h-100">
        <div className="d-flex flex-row align-items-center">
          <div className="pl-2 d-flex flex-column">
            <span className="document-facility-info1">
              {selectedDocTypeData?.FirstName +
                ' ' +
                selectedDocTypeData?.LastName}
            </span>
            <span className="document-facility-info2">
              User type: {selectedDocTypeData.MemberType}
            </span>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div>
            <div className="text-right">
              {selectedDocTypeData.CertificateNumber && (
                <div className="pr-3 document-facility-info2">
                  Member ID: {selectedDocTypeData.CertificateNumber}
                </div>
              )}
            </div>
            <div className="text-right">
              {getMaskedSsn(selectedDocTypeData?.SSN) && (
                <div className="pr-3 document-facility-info2">
                  SSN: {getMaskedSsn(selectedDocTypeData?.SSN)}
                </div>
              )}
            </div>
          </div>
          <div className="trash-div">
            <button
              type="button"
              className="trash-button"
              onClick={deleteSelectedDocype}
            >
              <TrashIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { BlobCard, DoctorCard, BrokerCard, MemberDependentCard };
